import { FC } from 'react';

import IconClose from 'src/assets/images/icons/close-circle-neutral.svg';
import { DisputeResultProps } from './types';
import { DisputeResult } from '../dispute/DisputeResult';

export const MainDetailsDisputeResult: FC<DisputeResultProps> = (props) => {
  const { invoiceSummary } = props;

  if (!invoiceSummary?.invoiceDispute) {
    return (
      <div className='-mx-24 flex items-center justify-center flex-1 h-[18.5rem] border-b border-neutral-20'>
        <div className='flex flex-col items-center justify-center gap-12'>
          <img src={IconClose} alt='' className='w-40 xl:w-60' />
          <p className='text-14 xl:text-16 text-blue_grey-30'>No dispute</p>
        </div>
      </div>
    );
  }
  return (
    <div className='mt-24 px-24 pb-20  overflow-y-auto'>
      <DisputeResult invoiceSummary={invoiceSummary} />
    </div>
  );
};
